import Skeleton from "react-loading-skeleton";

export function AssignedSupervisorSelectSkeleton() {
  return (
    <div>
      <Skeleton height={12} width={120} />
      <Skeleton height={38} />
    </div>
  );
}
